<template>
  <div class="xjsrdzd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <!-- 搜索条件 -->
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="searchForm.type" style="width: 130px" clearable>
                <el-option :label="typeList[0]" :value="0" />
                <el-option :label="typeList[1]" :value="1" />
                <el-option :label="typeList[3]" :value="3" />
                <el-option :label="typeList[5]" :value="5" />
                <el-option :label="typeList[6]" :value="6" />
                <el-option :label="typeList[7]" :value="7" />
                <el-option :label="typeList[8]" :value="8" />
                <el-option :label="typeList[10]" :value="10" />
                <el-option :label="typeList[11]" :value="11" />
                <el-option :label="typeList[12]" :value="12" />
                <el-option :label="typeList[13]" :value="13" />
                <el-option :label="typeList[14]" :value="14" />
                <el-option :label="typeList[15]" :value="15" />
                <el-option :label="typeList[25]" :value="25" />
                <el-option :label="typeList[26]" :value="26" />
                <el-option :label="typeList[77]" :value="77" />
                <el-option :label="typeList[88]" :value="88" />
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="收款账户">
              <el-select v-model="searchForm.aid" style="width:300px" placeholder="请选择" clearable filterable>
                <el-option-group
                  v-for="gitem in groupList"
                  v-if="gitem.nature===0"
                  :key="gitem.groupid"
                  :label="gitem.account_name"
                >
                  <el-option
                    v-for="item in accountsList"
                    v-if="item.groupid===gitem.groupid"
                    :key="item.aid"
                    :label="item.name+'（'+item.card+'）'"
                    :value="item.aid"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="print">打印对账单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <!-- 表格内容 -->
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                label="类型"
                width="140"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ typeList[scope.row.assType] }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="140"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.dealerName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商电话"
                width="110"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.dealerTel }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="省"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="市"
                width="90"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.city }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="区"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.county }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="经销商区域"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province+scope.row.city+scope.row.county }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="内容"
                width="600"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.assType==0">系统历史数据</span>
                  <span v-if="scope.row.assType==1||scope.row.assType==6||scope.row.assType==7||scope.row.assType==8||scope.row.assType==10||scope.row.assType==25">
                    <span style="color:#99a9bf">订单信息：</span>
                    <span>{{ scope.row.orderNum }}/{{ scope.row.produnum }}，{{ scope.row.address }}</span>
                  </span>
                  <span v-if="scope.row.assType==3||scope.row.assType==11||scope.row.assType==12">
                    <span style="color:#99a9bf">收款账户：</span>
                    <span>{{ scope.row.accountName }}({{ scope.row.accountCard }})</span>
                  </span>
                  <span v-if="scope.row.assType==5">
                    <span style="color:#99a9bf">划账信息：</span>
                    <span>失效报备金自动转入账户余额</span>
                  </span>
                  <span v-if="scope.row.assType==13">
                    <span style="color:#99a9bf">返点信息：</span>
                    <span>{{ scope.row.accountName }}，共{{ scope.row.money }}元</span>
                  </span>
                  <span v-if="scope.row.assType==14">
                    <span style="color:#99a9bf">赔款信息：</span>
                    <span>{{ scope.row.accountName }}，共{{ scope.row.money }}元</span>
                  </span>
                  <span v-if="scope.row.assType==15">
                    <span style="color:#99a9bf">报备信息：</span>
                    <span>{{ scope.row.accountName }}，收款账户{{ scope.row.orderNum }}({{ scope.row.produnum }}),打款卡号{{ scope.row.address }}共{{ scope.row.money }}元</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                align="center"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="时间"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptTime }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 账户充值，收款申请详情 -->
    <el-dialog
      title="收款申请详情"
      :visible.sync="receiptApplyVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="receiptApplyLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ receiptApplyData.applyname }}</td>
          <th>申请时间</th>
          <td>{{ receiptApplyData.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ receiptApplyData.dealerName }}</td>
          <th>卡号</th>
          <td>{{ receiptApplyData.card }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">{{ receiptApplyData.accountname }}（{{ receiptApplyData.accountcard }}）</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ receiptApplyData.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ receiptApplyData.nature }}</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td colspan="3" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ receiptApplyData.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgReceiptApplySrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReceiptApplySrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ receiptApplyData.remark }}</td>
        </tr>
        <tr v-if="receiptApplyData.mark===2||receiptApplyData.mark===1">
          <th>审核人</th>
          <td>{{ receiptApplyData.auditname }}</td>
          <th>审核时间</th>
          <td>{{ receiptApplyData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="receiptApplyVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 样品预存款账户抵扣等，订单收款详细 -->
    <el-dialog
      title="订单收款详细"
      :visible.sync="collectRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="collectRecordLoading" class="tcf-detail-table">
        <tr>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td>{{ collectRecordData.time }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.productNum }}</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ collectRecordData.receipttime }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</td>
        </tr>
        <tr>
          <th>收款内容</th>
          <td>{{ collectRecordData.paycontent }}</td>
          <th>卡号</th>
          <td>{{ collectRecordData.type == 0 ? '账户余额抵扣' : (collectRecordData.type == 8 ? '样品预存款抵扣' : collectRecordData.card) }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="collectRecordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 样品预存款收款明细 -->
    <el-dialog
      title="样品预存款收款明细"
      :visible.sync="jmDetailVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="jmFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ jmDetail.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ jmDetail.time }}</td>
        </tr>
        <tr>
          <th>店面形式</th>
          <td>{{ jmDetail.shopform===1?'店中店':jmDetail.shopform===2?'沿街店':'商场内店' }}</td>
          <th>门店地址</th>
          <td>{{ jmDetail.address }}</td>
        </tr>
        <tr>
          <th>总面积</th>
          <td>{{ jmDetail.totalarea }}</td>
          <th>本品牌<br />占店面积</th>
          <td>{{ jmDetail.area }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td>{{ jmDetail.all_name }}</td>
          <th>卡号</th>
          <td>{{ jmDetail.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            {{ jmDetail.accountname }}（{{ jmDetail.accountcard }}）
            <!-- <span v-for="av in jmDetail.accountVoList" v-if="av.is_select===1" :key="av.card">{{ av.account_name }}（{{ av.card }}）</span> -->
          </td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ jmDetail.pay_time }}</td>
          <th>打款金额</th>
          <td>{{ jmDetail.pay_price }}（样品预存款：{{ jmDetail.joins }}，加盟费：{{ jmDetail.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in jmImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="jmImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ jmDetail.remark }}</td>
        </tr>
        <tr v-if="jmDetail.joinType===0 && (jmDetail.mark===1||jmDetail.mark===2||jmDetail.mark===4||jmDetail.mark===9)">
          <th>招商总监</th>
          <td>{{ jmDetail.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ jmDetail.dirtime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===2||jmDetail.mark===4||jmDetail.mark===9 || (jmDetail.joinType===1 && jmDetail.mark>0)">
          <th>财务审核</th>
          <td>{{ jmDetail.auditname }}</td>
          <th>审核时间</th>
          <td>{{ jmDetail.audittime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===4 || (jmDetail.joinType===1 && jmDetail.mark===1)">
          <th>财务驳回原因</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
        <tr v-if="((jmDetail.joinType===0&&jmDetail.mark===1) || (jmDetail.joinType===1&&jmDetail.mark===0)) && jmDetail.rson">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="jmDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 意向金收款明细 -->
    <el-dialog
      title="意向金收款明细"
      :visible.sync="yxDetailVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="yxFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请日期</th>
          <td>{{ yxDetail.time }}</td>
          <th>意向加盟地区</th>
          <td>{{ yxDetail.province }}{{ yxDetail.city }}</td>
          <th>意向加盟品牌</th>
          <td>{{ yxDetail.brandname }}</td>
        </tr>
        <tr>
          <th>客户姓名</th>
          <td>{{ yxDetail.name }}</td>
          <th>联系电话</th>
          <td>{{ yxDetail.tel }}</td>
          <th>招商经理</th>
          <td>{{ yxDetail.username }}</td>
        </tr>
        <tr>
          <th>意向金享受权限</th>
          <td colspan="5">{{ yxDetail.enjoy }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ yxDetail.accountsname }}（{{ yxDetail.accountscard }}）</td>
        </tr>
        <tr>
          <th>意向金</th>
          <td style="color: #409EFF;font-weight: bold">{{ yxDetail.money }}</td>
          <th>打款日期</th>
          <td>{{ yxDetail.receipttime }}</td>
          <th>打款卡号</th>
          <td>{{ yxDetail.card }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in yxImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="yxImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ yxDetail.remark }}</td>
        </tr>
        <tr v-if="yxDetail.mark===1||yxDetail.mark===2||yxDetail.mark===4||yxDetail.mark===9">
          <th>招商总监</th>
          <td>{{ yxDetail.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ yxDetail.dirtime }}</td>
        </tr>
        <tr v-if="yxDetail.mark===2||yxDetail.mark===4||yxDetail.mark===9">
          <th>财务审核</th>
          <td>{{ yxDetail.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ yxDetail.audittime }}</td>
        </tr>
        <tr v-if="yxDetail.mark===4">
          <th>财务驳回原因</th>
          <td colspan="5" style="color:#f56c6c">{{ yxDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="yxDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 业绩/支票返点详情 -->
    <el-dialog
      title="业绩/支票返点详情"
      :visible.sync="viewRebateVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewRebateLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewRebatedata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewRebatedata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewRebatedata.delname }}</td>
          <th>返点名称</th>
          <td colspan="3" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date" /> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date" /> {{ viewRebatedata.starttime }} ~ {{ viewRebatedata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.amount }}</td>
          <th>返点余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{ viewRebatedata.maximpact }}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{ viewRebatedata.maxdiscount }}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewRebatedata.orderMoney }} 元以上可享受，同比享受最低折扣不低于 {{ viewRebatedata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgRebateSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgRebateSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr v-if="viewRebatedata.mark===2">
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 售后赔款详情 -->
    <el-dialog
      title="售后赔款详情"
      :visible.sync="viewAfterVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewAfterLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewAfterdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewAfterdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewAfterdata.delname }}</td>
          <th>赔款名称</th>
          <td colspan="3" style="color:#000;">{{ viewAfterdata.name }}</td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.amount }}</td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewAfterdata.credit===0">最高冲抵{{ viewAfterdata.maximpact }}%</span>
            <span v-if="viewAfterdata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewAfterdata.ordertype===0">无限制</span>
            <span v-if="viewAfterdata.ordertype===1">正单</span>
            <span v-if="viewAfterdata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{ viewAfterdata.orderMoney }} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgAfterSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgAfterSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewAfterdata.remark }}</td>
        </tr>
        <tr v-if="viewAfterdata.mark===2">
          <th>审核人</th>
          <td>{{ viewAfterdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewAfterdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewAfterVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 报备金详情 -->
    <el-dialog
      title="报备金详情"
      :visible.sync="viewReportVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewReportLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewReportdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewReportdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewReportdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{ viewReportdata.per }}/单
          </td>
          <th>账户余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.balance }}</td>
          <td colspan="2">
            同比享受最低折扣不低于 {{ viewReportdata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
                <td>
                  <span v-if="d.orderid!==null&&d.orderid!==''&&d.orderid!==undefined" style="color:#409EFF;cursor: pointer" @click="goOrder(d.orderid)"><i class="el-icon-document" /> <span v-if="d.produnum===null||d.produnum===''||d.produnum===undefined">{{ d.ordernum }}</span><span v-if="d.produnum!==null&&d.produnum!==''&&d.produnum!==undefined">{{ d.produnum }}</span></span>
                  <el-tag v-if="d.orderid===null||d.orderid===''||d.orderid===undefined" :disable-transitions="true" size="mini" type="danger">未关联</el-tag>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date" /> {{ viewReportdata.starttime }} ~ {{ viewReportdata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewReportAcccount.groupname }}（{{ viewReportAcccount.name }}，{{ viewReportAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewReportdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewReportdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgReportSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReportSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr v-if="viewReportdata.mark===2">
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAccounts, getGroupReport } from '@/api/pub'
import { getMerchantsMoneyDetail, getClientInmonDetail } from '@/api/work'
import {
  getReceiptApplyByRaid, getCollectRecordByCrid, getDealerAccountReportById, getDealerAccountAfterById,
  getDealerAccountRebateById, getDealerAccountsStatement, getDealerJoinApplyById,
  excelDealerAccountsStatement, printDealerAccountsStatement,
} from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'jxsdzd',
  data() {
    return {
      typeList: {
        0: '预存款',
        1: '余额抵扣',
        3: '余额充值',
        5: '报备金过期',
        6: '返点抵扣',
        7: '售后赔款抵扣',
        8: '报备金抵扣',
        10: '样品预存款抵扣',
        11: '样品预存款',
        12: '意向金',
        13: '业绩返点',
        14: '售后赔款',
        15: '报备金充值',
        25: '冲业绩抵扣',
        26: '零售抵扣',
        77: '冲业绩余额划账',
        88: '其他收款'
      },
      groupList: [],
      accountsList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        time: [],
        type: null,
        aid: null,
        groupid: null,
        search: null
      },
      tableData: [],
      loading: false,
      pringLoading: false,
      excelLoading: false,
      // 样品预存款信息
      jmFullscreenLoading: false,
      jmDetailVisible: false,
      jmDetail: [],
      jmImgSrcList: [],
      // 意向金信息
      yxFullscreenLoading: false,
      yxDetailVisible: false,
      yxDetail: [],
      yxImgSrcList: [],
      // 业绩/支票返点详情
      viewRebateVisible: false,
      viewRebateLoading: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      // 售后赔款详情
      viewAfterVisible: false,
      viewAfterLoading: false,
      viewAfterdata: [],
      imgAfterSrcList: [],
      // 报备金充值
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      // 样品预存款账户抵扣等，订单收款详细
      collectRecordVisible: false,
      collectRecordLoading: false,
      collectRecordData: [],
      // 收款申请（账户余额充值）
      receiptApplyVisible: false,
      receiptApplyLoading: false,
      receiptApplyData: [],
      imgReceiptApplySrcList: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      const data = {
        aid: this.searchForm.aid,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getDealerAccountsStatement(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    openDetails(row) {
      // todo 6、7、8详情之后再优化
      if (row.assType === '0') { // 预存款
      } else if (row.assType === '1') { // 账户余额抵扣
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.assId }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.assType === '3') { // 账户余额充值
        this.imgReceiptApplySrcList = []
        this.receiptApplyVisible = true
        this.receiptApplyLoading = true
        getReceiptApplyByRaid({ raid: row.assId }).then(response => {
          this.receiptApplyLoading = false
          this.receiptApplyData = response.data
          const imgs = []
          for (const c of this.receiptApplyData.imglst) {
            imgs.push(c.img_url)
          }
          this.imgReceiptApplySrcList = imgs
        }).catch(() => {
          this.receiptApplyData = []
          this.receiptApplyLoading = false
        })
      } else if (row.assType === '5') { // 过期报备金转余额
      } else if (row.assType === '6') { // 业绩支票返点抵扣
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.assId }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.assType === '7') { // 售后赔款抵扣
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.assId }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.assType === '8' || row.assType === '88') { // 报备金抵扣
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.assId }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.assType === '10') { // 样品预存款账户抵扣
        this.collectRecordVisible = true
        this.collectRecordLoading = true
        getCollectRecordByCrid({ crid: row.assId }).then(response => {
          this.collectRecordData = response.data
          this.collectRecordLoading = false
        }).catch(() => {
          this.collectRecordData = []
          this.collectRecordLoading = false
        })
      } else if (row.assType === '11') { // 样品预存款打款
        this.jmImgSrcList = []
        this.jmDetailVisible = true
        this.jmFullscreenLoading = true
        // 样品预存款申请
        if (row.joinType === 1) {
          getDealerJoinApplyById({
            djaid: row.assId,
            userid: this.user.dUserid
          }).then(response => {
            this.jmDetail = response.data
            const imgs = []
            for (const c of this.jmDetail.imgList) {
              imgs.push(c.img_url)
            }
            this.jmImgSrcList = imgs
            this.jmFullscreenLoading = false
          }).catch(() => {
            this.jmFullscreenLoading = false
          })
          return
        }
        getMerchantsMoneyDetail({ payid: row.assId, userid: this.user.dUserid }).then(response => {
          this.jmFullscreenLoading = false
          this.jmDetail = response.data
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
      } else if (row.assType === '12') { // 意向金打款
        this.yxImgSrcList = []
        this.yxDetailVisible = true
        this.yxFullscreenLoading = true
        getClientInmonDetail({ ciid: row.assId }).then(response => {
          this.yxFullscreenLoading = false
          this.yxDetail = response.data
          const imgs = []
          for (const c of this.yxDetail.imglst) {
            imgs.push(c.imgurl)
          }
          this.yxImgSrcList = imgs
        }).catch(() => {
          this.yxFullscreenLoading = false
        })
      } else if (row.assType === '13') { // 给与业绩返点
        this.imgRebateSrcList = []
        this.viewRebateVisible = true
        this.viewRebateLoading = true
        getDealerAccountRebateById({ darid: row.assId }).then(response => {
          this.viewRebateLoading = false
          this.viewRebatedata = response.data.dar
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgRebateSrcList = imgs
        }).catch(() => {
          this.viewRebateLoading = false
        })
      } else if (row.assType === '14') { // 给与售后赔款
        this.imgAfterSrcList = []
        this.viewAfterVisible = true
        this.viewAfterLoading = true
        getDealerAccountAfterById({ daaid: row.assId }).then(response => {
          this.viewAfterLoading = false
          this.viewAfterdata = response.data.daa
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgAfterSrcList = imgs
        }).catch(() => {
          this.viewAfterLoading = false
        })
      } else if (row.assType === '15') { // 报备金充值
        this.imgReportSrcList = []
        this.viewReportVisible = true
        this.viewReportLoading = true
        getDealerAccountReportById({ darid: row.assId }).then(response => {
          this.viewReportLoading = false
          this.viewReportdata = response.data.dar
          this.viewReportAddress = response.data.daralst
          this.viewReportDiscount = response.data.dardlst
          this.viewReportAcccount = response.data.acccount
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgReportSrcList = imgs
        }).catch(() => {
          this.viewReportLoading = false
        })
      }
    },
    goOrder(orderid) {
      this.collectRecordVisible = false
      this.receiptAccountVisible = false
      this.viewReportVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          if (this.total > 1000) {
            if (starttime === '' && endtime === '') {
              this.$message({
                message: '由于数据量过多，请进行筛选再打印',
                type: 'warning'
              })
              return false
            }
          }
          this.pringLoading = true
          const data = {
            aid: this.searchForm.aid,
            type: this.searchForm.type,
            content: this.searchForm.search,
            starttime: starttime,
            endtime: endtime,
            groupid: this.user.dGroupid
          }
          printDealerAccountsStatement(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('经销商账户对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    exportExcel() {
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      if (this.total > 1000) {
        if (starttime === '' && endtime === '') {
          this.$message({
            message: '由于数据量过多，请进行筛选再导出',
            type: 'warning'
          })
          return false
        }
      }
      this.$message({
        message: '数据正在导出，请稍候'
      })
      this.excelLoading = true
      const data = {
        aid: this.searchForm.aid,
        type: this.searchForm.type,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        groupid: this.user.dGroupid
      }
      excelDealerAccountsStatement(data).then(response => {
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            _this.excelLoading = false
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.excelLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
